var map = {
	"./img_1.jpg": 37812,
	"./img_2.jpg": 50636,
	"./img_3.jpg": 24313,
	"./img_4.jpg": 58540,
	"./img_5.jpg": 77272,
	"./img_6.jpg": 77558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48059;